export const accountTypes = {
  CUSTOMER: "CUSTOMER",
  MEMBER: "MEMBER",
};
